// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3k3lT","log":"ModalInventoryLogs_log__2eHzC","date":"ModalInventoryLogs_date__1T0BL","userName":"ModalInventoryLogs_userName__a169I"};